import { render } from "./aRowId.vue?vue&type=template&id=0ccd7cd0"
import script from "./aRowId.vue?vue&type=script&lang=js"
export * from "./aRowId.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__